(() => {
  const all = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  const stepAnnouncement = (root, dir) => {
    const items = all('[data-bbd-ann-item]', root);
    if (items.length < 2) return;
    let index = items.findIndex((item) => item.classList.contains('is-active'));
    if (index < 0) index = 0;
    items[index].classList.remove('is-active');
    index = (index + dir + items.length) % items.length;
    items[index].classList.add('is-active');
  };

  const initAnnouncements = () => {
    all('[data-bbd-ann]').forEach((root) => {
      if (root.dataset.bbdAnnReady) return;
      root.dataset.bbdAnnReady = '1';
      const items = all('[data-bbd-ann-item]', root);
      if (items[0]) items[0].classList.add('is-active');
      const speed = Number(root.dataset.bbdAnnSpeed || 4500);
      if (items.length > 1) {
        root._bbdTimer = setInterval(() => {
          if (!document.body.contains(root)) {
            clearInterval(root._bbdTimer);
            return;
          }
          stepAnnouncement(root, 1);
        }, speed);
      }
    });
  };

  const setComparePosition = (stage, clientX) => {
    const rect = stage.getBoundingClientRect();
    let pos = ((clientX - rect.left) / rect.width) * 100;
    pos = Math.max(0, Math.min(100, pos));
    stage.style.setProperty('--pos', `${pos}%`);
  };

  document.addEventListener('pointerdown', (event) => {
    const stage = event.target.closest('[data-bbd-compare]');
    if (!stage || event.target.closest('a, button')) return;
    setComparePosition(stage, event.clientX);
    const onMove = (moveEvent) => setComparePosition(stage, moveEvent.clientX);
    const onUp = () => {
      window.removeEventListener('pointermove', onMove);
      window.removeEventListener('pointerup', onUp);
      window.removeEventListener('pointercancel', onUp);
    };
    window.addEventListener('pointermove', onMove);
    window.addEventListener('pointerup', onUp);
    window.addEventListener('pointercancel', onUp);
  });

  document.addEventListener('click', (event) => {
    const tab = event.target.closest('[data-bbd-tab]');
    if (tab) {
      const root = tab.closest('[data-bbd-tabs]');
      if (!root) return;
      const value = tab.dataset.bbdTab;
      all('[data-bbd-tab]', root).forEach((item) => item.classList.toggle('is-active', item === tab));
      all('[data-bbd-card]', root).forEach((card) => {
        const tags = (card.dataset.tags || '').split(',').map((tag) => tag.trim().toLowerCase());
        card.hidden = !(value === 'all' || tags.includes(value));
      });
      const rail = root.querySelector('[data-bbd-rail]');
      if (rail) rail.scrollTo({ left: 0, behavior: 'smooth' });
      return;
    }

    const railButton = event.target.closest('[data-bbd-rail-btn]');
    if (railButton) {
      const root = railButton.closest('[data-bbd-rail-root]');
      const rail = root && root.querySelector('[data-bbd-rail]');
      if (!rail) return;
      const first = Array.from(rail.children).find((child) => !child.hidden);
      const step = first ? first.getBoundingClientRect().width + 14 : rail.clientWidth * 0.8;
      const dir = railButton.dataset.bbdRailBtn === 'prev' ? -1 : 1;
      rail.scrollBy({ left: dir * step * 2, behavior: 'smooth' });
      return;
    }

    const annButton = event.target.closest('[data-bbd-ann-btn]');
    if (annButton) {
      const root = annButton.closest('[data-bbd-ann]');
      if (root) stepAnnouncement(root, annButton.dataset.bbdAnnBtn === 'prev' ? -1 : 1);
      return;
    }

    const opener = event.target.closest('[data-bbd-drawer-open]');
    if (opener) {
      const drawer = document.getElementById(opener.dataset.bbdDrawerOpen);
      if (drawer) {
        drawer.classList.add('is-open');
        document.documentElement.classList.add('bbd-lock');
      }
      return;
    }

    const closer = event.target.closest('[data-bbd-drawer-close]');
    if (closer) {
      const drawer = closer.closest('.bbd-drawer');
      if (drawer) {
        drawer.classList.remove('is-open');
        document.documentElement.classList.remove('bbd-lock');
      }
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    all('.bbd-drawer.is-open').forEach((drawer) => drawer.classList.remove('is-open'));
    document.documentElement.classList.remove('bbd-lock');
  });

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-bbd-quick-add]');
    if (!form || !window.fetch) return;
    event.preventDefault();
    const button = form.querySelector('button[type="submit"]');
    const label = button ? button.innerHTML : '';
    if (button) {
      button.disabled = true;
      button.textContent = button.dataset.loading || '...';
    }
    fetch(`${window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/'}cart/add.js`, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form),
    })
      .then((response) => {
        if (!response.ok) throw new Error('add');
        return fetch(`${window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/'}cart.js`);
      })
      .then((response) => response.json())
      .then((cart) => {
        all('[data-bbd-cart-count]').forEach((badge) => {
          badge.textContent = cart.item_count;
          badge.hidden = cart.item_count === 0;
        });
        if (button) button.textContent = button.dataset.added || 'Added';
        setTimeout(() => {
          if (button) {
            button.innerHTML = label;
            button.disabled = false;
          }
        }, 1600);
      })
      .catch(() => form.submit());
  });

  initAnnouncements();
  document.addEventListener('shopify:section:load', initAnnouncements);
})();
